import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"
import ImportJobActionResult from "./Model/ImportJobActionResult"

export default function ImportJobMappingSetObservable(importJobID: number, selectedFields: string[]): Observable<ImportJobActionResult> {
  const params: string = JSON.stringify({
    ImportJobID: importJobID,
    SelectedFields: selectedFields
  })
  return ObservableFromFetch<ImportJobActionResult>("WorkforceImport/MapDropDownFields", params)
}
